import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mergeMap } from "rxjs/operators";
import { ConfigService } from '../../../../config/config.service';
import { ArticleGenerique } from '../../../delivery/shared/article-generique/article-generique';
import { ClientService } from '../client.service';
import { Change } from './changes';
import { LigneContrat } from './ligne-contrat';
import { Taille } from './taille';

@Injectable({
  providedIn: 'root'
})
export class ContratService {

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private clientService: ClientService
  ) { }

  getTailles(article: ArticleGenerique, code_service?: string): Observable<Array<Taille>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {

        if (code_service === undefined) {
          code_service = (this.clientService.modifCodeService == null ? this.clientService.currentClient$.getValue().code_service : this.clientService.modifCodeService);
        }

        return this.http.get<Array<Taille>>(config.apiPoint + config.getClientArticleTaille
          .replace('{client}', this.clientService.currentClient$.getValue().id)
          .replace('{codeArticle}', article.code_article)
          .replace('{codeService}', code_service));
      })
    );
  }

  getChanges(article: ArticleGenerique, code_service?: string): Observable<Array<Change>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {

        if (code_service === undefined) {
          code_service = (this.clientService.modifCodeService == null ? this.clientService.currentClient$.getValue().code_service : this.clientService.modifCodeService);
        }

        return this.http.get<Array<Change>>(config.apiPoint + config.getClientArticleChange
          .replace('{client}', this.clientService.currentClient$.getValue().id)
          .replace('{codeArticle}', article.code_article)
          .replace('{codeService}', code_service));
      })
    );
  }

  getArticleVT(code_service?: string): Observable<Array<ArticleGenerique>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        if (code_service === undefined) {
          code_service = (this.clientService.modifCodeService == null ? this.clientService.currentClient$.getValue().code_service : this.clientService.modifCodeService);
        }
        return this.http.get<Array<ArticleGenerique>>(config.apiPoint + config.getClientContratArticlesVT
          .replace('{client}', this.clientService.currentClient$.getValue().id)
          .replace('{codeService}', code_service));
      })
    );
  }

  getLignesContratLP(): Observable<Array<LigneContrat>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => this.clientService.getFirstCurrentClient().pipe(
        mergeMap(client => {
          return this.http.get<Array<LigneContrat>>(
            config.apiPoint + config.getClientContratArticlesLP
              .replace('{client}', client.id));
        }
        )
      )
      )
    );
  }

  getLigneContratLP(code_article: string): Observable<LigneContrat> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<LigneContrat>(
          config.apiPoint + config.getClientContratArticleLP
            .replace('{client}', this.clientService.currentClient$.getValue().id)
            .replace('{article}', code_article));
      })
    );
  }
}
